import { Button } from "@/components/ui/button"
import { Card } from "@/components/ui/card"
import { CatalogEntry } from "@/types/database/opportunity"
import { useNavigate } from "react-router-dom"
import { Calendar, Users, Clock, MapPin, Target } from "lucide-react"

interface OpportunityBookingPanelProps {
  opportunity: CatalogEntry
  npoSlug: string
  catalogSlug: string
  profile: any | null
  session: any | null
}

export function OpportunityBookingPanel({ opportunity, npoSlug, catalogSlug, profile, session }: OpportunityBookingPanelProps) {
  const navigate = useNavigate()

  const handleBookNow = async () => {
    navigate(`/checkout/${npoSlug}/${catalogSlug}`)
  }

  return (
    <Card className="p-6 space-y-6 sticky top-4">
      <div>
        <h3 className="font-medium mb-2">Type & Impact</h3>
        <div className="space-y-2">
          <div className="flex items-center gap-2 text-gray-600">
            <Target className="h-4 w-4" />
            <span>{opportunity.opportunity.type}</span>
          </div>
          <p className="text-gray-600 text-sm">{opportunity.opportunity.impact}</p>
        </div>
      </div>

      <div>
        <h3 className="font-medium mb-2">UN Days</h3>
        <div className="flex flex-wrap gap-2">
          {opportunity.opportunity.relevant_un_day?.map((day) => (
            <div key={day} className="flex items-center gap-2 text-gray-600">
              <Calendar className="h-4 w-4" />
              <span className="text-sm">{day}</span>
            </div>
          ))}
        </div>
      </div>

      <div>
        <h3 className="font-medium mb-2">SDG Alignment</h3>
        <div className="flex flex-wrap gap-2">
          {opportunity.opportunity.sdg_alignment?.map((sdg) => (
            <span 
              key={sdg} 
              className="inline-flex items-center rounded-full bg-green-50 px-2 py-1 text-xs text-green-700"
            >
              {sdg}
            </span>
          ))}
        </div>
      </div>

      <div className="space-y-4">
        <div>
          <h3 className="font-medium mb-2">Event Details</h3>
          <div className="space-y-2">
            <div className="flex items-center gap-2 text-gray-600">
              <Clock className="h-4 w-4" />
              <span>{opportunity.duration}</span>
            </div>
            <div className="flex items-center gap-2 text-gray-600">
              <MapPin className="h-4 w-4" />
              <span>{opportunity.format} ({opportunity.format_details})</span>
            </div>
            <div className="flex items-center gap-2 text-gray-600">
              <Users className="h-4 w-4" />
              <span>{opportunity.min_volunteers} - {opportunity.max_volunteers} volunteers</span>
            </div>
            <div className="flex items-center gap-2 text-gray-600">
              <Users className="h-4 w-4" />
              <span>Host {opportunity.host_included ? 'Included' : 'Not Included'}</span>
            </div>
          </div>
        </div>

        <div>
          <h3 className="font-medium mb-2">Event Cost</h3>
          <p className="text-gray-600">
            {opportunity.event_cost ? `$${opportunity.event_cost.toLocaleString()}` : 'Free'}
          </p>
        </div>

        <div>
          <h3 className="font-medium mb-2">Community Need</h3>
          <p className="text-gray-600 text-sm whitespace-pre-wrap">
            {opportunity.opportunity.community_need}
          </p>
        </div>
      </div>

      {profile?.user_type !== 'nonprofit' && (
        <Button className="w-full" onClick={handleBookNow}>
          Book Now
        </Button>
      )}
    </Card>
  )
}